(ns app.front.view.party.subs
  (:require
    [app.domain.contractor-registration.model :as cr-model]
    [app.domain.party.model :as party-model]
    [app.front.entities :as entities]
    [clojure.set :as set]
    [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::parties
  (fn [[_ phase-id]]
    (rf/subscribe [::entities/entities {:entity/type   :entity.type/party
                                        :entity/parent phase-id}]))
  (fn [parties _]
    (->> parties
         (sort-by :entity/created))))

(rf/reg-sub ::business-parties-for-current-user
  (fn [[_ target-id]]
    (rf/subscribe [::parties target-id]))
  (fn [parties _]
    (->> parties
         (filter (comp seq :granted-permissions :party/business)))))

(rf/reg-sub ::parties-with-missing-required-trade+role-ids
  (fn [[_ target-id]]
    (rf/subscribe [::parties target-id]))
  (fn [parties _]
    (reduce (fn [acc party]
              (let [roles-with-trade         (filter :party-role/trade (:party/party-roles party))
                    party-trades             (some->> (cr-model/party-entity->registrations party)
                                                      (mapcat cr-model/contractor-registration-trades)
                                                      cr-model/registered-trades->work-type-ids)
                    roles-with-missing-trade (keep (fn [role]
                                                     (when (not (contains? party-trades (-> role :party-role/trade :db/id)))
                                                       (:db/id role)))
                                                   roles-with-trade)]
                (if (seq roles-with-missing-trade)
                  (assoc acc party roles-with-missing-trade)
                  acc)))
            {}
            parties)))

(rf/reg-sub ::parties-without-missing-trade
  (fn [[_ target-id]]
    [(rf/subscribe [::parties target-id])
     (rf/subscribe [::parties-with-missing-required-trade+role-ids target-id])])
  (fn [[parties parties-w-missing-trade+role-ids] _]
    (set/difference (set parties) (-> parties-w-missing-trade+role-ids keys set))))

(rf/reg-sub ::person-parties-for-current-user
  (fn [[_ target-id]]
    [(rf/subscribe [::parties target-id])
     (rf/subscribe [:session/user-id])])
  (fn [[parties user-id] _]
    (->> parties
         (filter #(some-> % :party/user :db/id (= user-id)))
         seq)))

(defn only-party-and-empty-other? [parties-to-consider other-parties party-id]
  (and (= 1 (count parties-to-consider))
       (some-> parties-to-consider first :db/id (= party-id))
       ;; not member of business that is a party
       (empty? other-parties)))

(rf/reg-sub ::only-party-of-user?
  (fn [[_ target-id _party-id]]
    [(rf/subscribe [::business-parties-for-current-user target-id])
     (rf/subscribe [::person-parties-for-current-user target-id])])
  (fn [[user-b-parties user-person-parties] [_ _ party-id]]
    (or (only-party-and-empty-other? user-b-parties user-person-parties party-id)
        ;; this is a business and I'm the member and there are no user parties for me
        (only-party-and-empty-other? user-person-parties user-b-parties party-id))))

(rf/reg-sub ::parties-for-current-user
  :<- [:session/user]
  (fn [user [_ phase-or-phase-id role-id-or-kw]]
    (let [phase (if (integer? phase-or-phase-id)
                  @(rf/subscribe [::entities/entity phase-or-phase-id])
                  phase-or-phase-id)]
      (party-model/parties-for-user user phase role-id-or-kw))))
